import { _ep4, _mw0, command } from "../commandBuilder";
import { CreateSession$ } from "../schemas/schemas_0";
export class CreateSessionCommand extends command(_ep4, _mw0, "CreateSession", CreateSession$) {
}
